import { render, staticRenderFns } from "./Settings.vue?vue&type=template&id=d1852aaa&scoped=true&"
import script from "./Settings.vue?vue&type=script&lang=js&"
export * from "./Settings.vue?vue&type=script&lang=js&"
import style0 from "./Settings.vue?vue&type=style&index=0&id=d1852aaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1852aaa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d1852aaa')) {
      api.createRecord('d1852aaa', component.options)
    } else {
      api.reload('d1852aaa', component.options)
    }
    module.hot.accept("./Settings.vue?vue&type=template&id=d1852aaa&scoped=true&", function () {
      api.rerender('d1852aaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/vendors/Settings.vue"
export default component.exports